import style from "./Fren.module.css";

import balance_icon from "/balance-icon-white.png";
import tether_green from "/tether-green.png";
import envelope_img from "/envelope-img.png";

const tg = window.Telegram.WebApp;

export default function Fren(props) {
  return (
    <div className={style["container"]}>
      <div className={style["user-info"]}>
        {props.img ? (
          <img
            onLoad={() => {
              let obj = {};
              obj[props.referrerName] = true;
            }}
            className={style["avatar"]}
            src={props.img}
          ></img>
        ) : (
          <div className={style["avatar-placeholder"]}>
            {props.name ? props.name.charAt(0).toUpperCase() : "?"}
          </div>
        )}
        <div className={style["user-name"]}>{props.name}</div>
      </div>
      <div className={style["reward-container"]}>
        <img src={props.coin_type == "DC" ? balance_icon : tether_green}></img>
        <div className={style["reward"]}>{props.reward}</div>
        <div className={style["coin-type"]}>{props.coin_type}</div>
      </div>
      <div className={style["message"]}>
        {props.link_profile ? (
          <img
            onClick={() => {
              try {
                tg.openTelegramLink(props.link_profile);
              } catch {
                tg.openLink(props.link_profile);
              }
            }}
            className={style["envelope"]}
            src={envelope_img}
          ></img>
        ) : (
          <div className={style["no-envelope"]}></div>
        )}
      </div>
    </div>
  );
}
